export default __webpack_public_path__ + "static/OpenSansRegular-47933c926e33fcf21f44326b59a54f62.eot";